import ManualTableI from '../types.ts';

const checkAdmin: ManualTableI['checkAdmin'] = function () {
    const { user } = this.state;

    return user?.idOfCurrentCorporation === 'admin';
};

export default checkAdmin;
